import { EventDispatcher } from "strongly-typed-events";

export class PaginationManager {

    private pageSizeElement: JQuery<Element>;
    private pageInfoElement: JQuery<Element>;
    private searchButtonContainer: JQuery<Element>;
    private searchButton: JQuery<Element>;

    public currentPage: number;
    public pageSize: number;
    private numberOfPages: number;
    private totalNumberOfItems: number;

    private startLink: JQuery<Element>;
    private previousLink: JQuery<Element>;
    private nextLink: JQuery<Element>;
    private endLink: JQuery<Element>;

    private clearButtonContainer: JQuery<Element>;
    private clearButton: JQuery<Element>;

    private onPageChange = new EventDispatcher<PaginationManager, number>();

    constructor(private pageNavigator: JQuery, defaultPageSize: number = 50, includeSearchButton: boolean = true) {
        var self = this;

        this.currentPage = 1;
        this.pageSize = defaultPageSize;
        this.pageSizeElement = pageNavigator.find("#pagination-select");
        this.pageSizeElement.val(this.pageSize);

        this.startLink = this.pageNavigator.find('.start-link');
        this.previousLink = this.pageNavigator.find('.previous-link');
        this.nextLink = this.pageNavigator.find('.next-link');
        this.endLink = this.pageNavigator.find('.end-link');

        this.clearButtonContainer = this.pageNavigator.find('#page-navigator-clear-button');
        this.clearButton = this.clearButtonContainer.children().first();

        this.pageInfoElement = this.pageNavigator.find('.page-info');

        this.searchButtonContainer = this.pageNavigator.find('#page-navigator-search-button');
        this.searchButton = this.searchButtonContainer.children().first();
        if(includeSearchButton) {
                this.searchButtonContainer.removeClass('d-none');
                this.searchButton.on('click', () => {
                    self.startSearch();


                this.setCurrentPage(1);
                this.onPageChange.dispatch(this, 1);
            });
        }

        this.pageSizeElement.each((index, element) => {
            var pse = $(element);
            pse.on('change', () => {
                this.pageSize = +pse.val();
                this.pageSizeElement.val(this.pageSize);
                this.currentPage = 1;
                this.onPageChange.dispatch(this, 1);
            });
        }); 
    }

    public startSearch() {
        var self = this;

        self.previousLink.attr('disabled', 'disabled');
        self.startLink.attr('disabled', 'disabled');
        self.nextLink.attr('disabled', 'disabled');
        self.endLink.attr('disabled', 'disabled');
        self.clearButton?.attr('disabled', 'disabled');
        self.searchButton.attr('disabled', 'disabled');
    }

    public bindAddButton(onAddButtonClickCallback: () => void) {
        var addButton = this.pageNavigator.find('#page-navigator-add-button');
        addButton.removeClass('d-none');
        addButton.children().first().on('click', () => {
            onAddButtonClickCallback();
        });    
    }

    public bindDownloadButton(onDownloadButtonClickCallback: () => void) {
        var downloadButton = this.pageNavigator.find('#page-navigator-download-button');
        downloadButton.removeClass('d-none');
        downloadButton.children().first().on('click', () => {
            onDownloadButtonClickCallback();
        });    
    }

    public disabledButtons() {
        this.previousLink.attr('disabled', 'disabled');
        this.startLink.attr('disabled', 'disabled');
        this.nextLink.attr('disabled', 'disabled');
        this.endLink.attr('disabled', 'disabled');
        this.clearButton?.attr('disabled', 'disabled');
        this.searchButton?.attr('disabled', 'disabled');
    }

    public bindClearButton(onClearButtonClickCallback: () => void) {
        this.clearButtonContainer.removeClass('d-none');
        this.clearButtonContainer.children().first().on('click', () => {

            this.previousLink.attr('disabled', 'disabled');
            this.startLink.attr('disabled', 'disabled');
            this.nextLink.attr('disabled', 'disabled');
            this.endLink.attr('disabled', 'disabled');
            this.clearButton.attr('disabled', 'disabled');
            this.searchButton?.attr('disabled', 'disabled');

            onClearButtonClickCallback();
        });    
    }

    get pageChanged() {
        return this.onPageChange.asEvent();
    }

    public setPageSize(pageSize : number) {
        this.pageSize = pageSize;
        this.pageSizeElement.val(pageSize);
    }

    public setCurrentPage(currentPage : number) {
        this.currentPage = currentPage;
    }

    setPagination(currentPage: number, pageSize: number, numberOfPages: number, totalNumberOfItems: number) {
        var self = this;

        this.previousLink.removeClass("active");
        this.nextLink.removeClass("active");

        if(currentPage <= 0 || currentPage == undefined || isNaN(currentPage)) {
            currentPage = 1;
        }

        this.currentPage = currentPage;
        this.pageSize = pageSize;
        this.numberOfPages = numberOfPages;
        this.totalNumberOfItems = totalNumberOfItems;

        var pageChangedFunction = () => {
            this.previousLink.attr('disabled', 'disabled');
            this.startLink.attr('disabled', 'disabled');
            this.nextLink.attr('disabled', 'disabled');
            this.endLink.attr('disabled', 'disabled');

            if(this.clearButtonContainer != undefined && this.clearButtonContainer.length > 0) {
                this.clearButton.attr('disabled', 'disabled');  
            }            
            
            if(this.searchButtonContainer != undefined && this.searchButtonContainer.length > 0) {
                this.searchButton.attr('disabled', 'disabled');  
            }
            
            this.onPageChange.dispatch(this, this.currentPage);
            //this.setPagination(this.currentPage, this.pageSize, this.numberOfPages, this.totalNumberOfItems);
        }

        if(this.clearButtonContainer != undefined && this.clearButtonContainer.length > 0) {
            this.clearButton.removeAttr('disabled');  
        }        
        
        if(this.searchButtonContainer != undefined && this.searchButtonContainer.length > 0) {
            this.searchButton.removeAttr('disabled');  
        }

        this.startLink.off('click').on('click', () => {
            this.currentPage = 1;
            pageChangedFunction();
        });

        this.previousLink.off('click').on('click', () => {

            this.currentPage = this.currentPage - 1;
            pageChangedFunction();
        });

        this.nextLink.off('click').on('click', () => {

            this.currentPage = this.currentPage + 1;
            pageChangedFunction();
        });

        this.endLink.off('click').on('click', () => {

            this.currentPage = this.numberOfPages;
            pageChangedFunction();
        });

        if(this.currentPage <= 1) {
            this.previousLink.attr('disabled', 'disabled');
            this.startLink.attr('disabled', 'disabled');
        }
        else {
            this.previousLink.removeAttr('disabled');
            this.startLink.removeAttr('disabled');
        }

        if(this.currentPage == this.numberOfPages) {
            this.nextLink.attr('disabled', 'disabled');
            this.endLink.attr('disabled', 'disabled');
        }
        else {
            this.nextLink.removeAttr('disabled');
            this.endLink.removeAttr('disabled');
        }

        var startItemIndex = ((currentPage-1) * pageSize) + 1;
        var endItemIndex = startItemIndex + pageSize - 1;

        if(totalNumberOfItems == undefined || Number.isNaN(totalNumberOfItems)) {
            totalNumberOfItems = 0;
        }
        
        if(startItemIndex <= 0 || startItemIndex == undefined || isNaN(startItemIndex) || totalNumberOfItems == 0) {
            startItemIndex = 0;
        }

        if(endItemIndex == undefined || isNaN(endItemIndex) || totalNumberOfItems == 0) {
            endItemIndex = 0
        }

        if(startItemIndex == 0 && endItemIndex == 0) {
            this.previousLink.attr('disabled', 'disabled');
            this.nextLink.attr('disabled', 'disabled');
            this.startLink.attr('disabled', 'disabled');
            this.endLink.attr('disabled', 'disabled');
        }

        if(this.currentPage == this.numberOfPages) {
            var endItemIndex = this.totalNumberOfItems;
        }

        this.pageInfoElement.text(`${startItemIndex.toLocaleString('en-US')}-${endItemIndex.toLocaleString('en-US')} of ${totalNumberOfItems.toLocaleString('en-US')}`);
    }
}